import React, { useEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoLight from "../../../assets/images/logo-light.png";
import { api } from "../../../config";
import moment from "moment";
import handleValidDate from "../../../helpers/utils/handleValidDate";

import logo from "../../../assets/images/logo-sm.png";
import logoDark from "../../../assets/images/logo-dark.png";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";

const PrintDoc = ({ innerRef, item, jobList, progressTotal, progressPrice, type, companyName, companyValue }) => {
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const validValue = (val) => {
    return <span className="courier">{`${val || "..................."}`}</span>;
  };

  const terbilang = (angka) => {
    const bilangan = [
      "", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"
    ];

    let temp = "";
    if (angka < 12) {
      temp = " " + bilangan[angka];
    } else if (angka < 20) {
      temp = terbilang(angka - 10) + " Belas";
    } else if (angka < 100) {
      temp = terbilang(Math.floor(angka / 10)) + " Puluh " + terbilang(angka % 10);
    } else if (angka < 200) {
      temp = " Seratus " + terbilang(angka - 100);
    } else if (angka < 1000) {
      temp = terbilang(Math.floor(angka / 100)) + " Ratus " + terbilang(angka % 100);
    } else if (angka < 2000) {
      temp = " Seribu " + terbilang(angka - 1000);
    } else if (angka < 1000000) {
      temp = terbilang(Math.floor(angka / 1000)) + " Ribu " + terbilang(angka % 1000);
    }

    return temp.trim();
  };

  // Fungsi utama formatter tanggal
  const formatTanggalIndonesia = (dateString) => {
    if (!dateString) return "";

    // Memecah input "dd/mm/yyyy"
    const parts = dateString.split('/');
    if (parts.length !== 3) return "Format tidak valid. Gunakan dd/mm/yyyy";

    const dayStr = parts[0];
    const monthStr = parts[1];
    const yearStr = parts[2];

    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10);
    const year = parseInt(yearStr, 10);

    // Validasi JS Date (Bulan di JS Date dimulai dari 0 = Januari)
    const dateObj = new Date(year, month - 1, day);

    // Array terjemahan
    const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    const months = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    const dayName = days[dateObj.getDay()];
    const monthName = months[month - 1];

    const dayText = terbilang(day);
    const yearText = terbilang(year); // Output "Dua Ribu Dua Puluh Enam" untuk 2026

    // Menyusun output akhir
    return `${dayName}, Tanggal ${dayText}, Bulan ${monthName}, Tahun ${yearText} (${dayStr}-${monthStr}-${yearStr})`;
  };

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/^Satu Juta\b/, "Sejuta");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  return item === undefined || item === null || jobList === undefined || jobList === null ? (
    <></>
  )
    :
    <div className="d-none">
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
        {type === "spk" ?
          <div className="hero-spk">
            {(companyValue === 1 || companyValue === 4) &&
              <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "10px" }}>
                <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                  <img src={logoHas} alt="" height="80" width="80" />
                </div>
                <div style={{ textAlign: "center", }}>
                  <p style={{ fontSize: "11px", margin: 0 }}>{companyName}</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                </div>
              </div>
            }

            {companyValue === 2 &&
              <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "10px" }}>
                <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                  <img src={logoCms} alt="" height="80" width="80" />
                </div>
                <div style={{ textAlign: "left" }}>
                  <p style={{ fontSize: "11px", margin: 0 }}>{companyName}</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                </div>
              </div>
            }

            {companyValue === 3 &&
              <div style={{ display: "flex", padding: "5px 0", alignItems: "center", justifyContent: "center", fontSize: "11px", marginBottom: "10px" }}>
                <div style={{ paddingRight: "30px", marginLeft: "-120px", width: "110px" }}>
                  <img src={logoWAP} alt="" height="80" width="80" />
                </div>
                <div style={{ textAlign: "left" }}>
                  <p style={{ fontSize: "11px", margin: 0 }}>{companyName}</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
                  <p style={{ fontSize: "11px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                </div>
              </div>
            }
            <div
              style={{
                height: "1px",
                width: "100%",
                backgroundColor: "black",
                marginBottom: "10px",

              }}></div>


            <div style={{ textAlign: "center", fontSize: "16px", marginBottom: "0px", fontWeight: "bold" }}>SURAT TUGAS</div>
            <div style={{ textAlign: "center", marginBottom: "20px", fontSize: "12px", fontWeight: "bold" }}>Nomor: {validValue(item?.transaction_no)}/{item?.cvl_contract_company?.code}-{item?.cvl_contract_branch?.branch_code}/ST/
              {moment().format("M")}/{moment().format("YYYY")}</div>
            <div>
              Pada hari ini {formatTanggalIndonesia(handleValidDate(item?.transactionat, "DD/MM/YYYY"))}.
              Yang bertanda tangan dibawah ini :
            </div>
            <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
              <tbody>
                <tr>
                  <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Nama </td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue(item?.cvl_contract_createdby?.name)}</td>
                </tr>
                <tr>
                  <td valign="top">Jabatan</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}><p className="mb-0">{validValue("MANAGER PROYEK")}</p>
                    {/* <p className="mb-0">Dalam hal ini bertindak untuk dan atas nama {companyName} – {item?.cvl_contract_branch?.name}</p> */}
                  </td>
                </tr>
                {/* <tr>
                            <td valign="top">Alamat</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                <tr>
                  <td valign="top">No. Hp</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                </tr>
                {/* <tr>
                            <td valign="top">No. KTP</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
              </tbody>
            </table>
            <div>
              Selanjutnya disebut sebagai : {validValue("PEMBERI TUGAS")}
            </div>
            <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
              <tbody>
                <tr>
                  <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Nama </td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue(item?.cvl_contract_vendor?.name)} &nbsp;</td>
                </tr>
                <tr>
                  <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>Jabatan </td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue("KOORDINATOR LAPANGAN")}
                    {/* <p className="mb-0">Dalam hal ini bertindak untuk dan atas nama diri sendiri</p> */}
                  </td>
                </tr>
                {/* <tr>
                            <td valign="top">Alamat</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
                <tr>
                  <td valign="top">No. Hp</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                </tr>
                {/* <tr>
                            <td valign="top">No. KTP</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("")}</td>
                          </tr> */}
              </tbody>
            </table>
            <div>
              Selanjutnya disebut sebagai : {validValue("PENERIMA TUGAS")}
            </div>

            {/* <p style={{ fontSize: "14px", marginTop: "15px", marginBottom: "15px", verticalAlign: "top" }}>
                        Berdasarkan : <br />- Penawaran Harga Pembangunan Perumahan {item?.cvl_contract_branch?.name}
                      </p> */}
            <div>Untuk segera melaksanakan pekerjaan Pembangunan Perumahan {item?.cvl_contract_branch?.name}  Type 30/60 M2 dengan ketentuan dan rincian sebagai berikut:</div>

            <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}>
              <tbody>
                <tr>
                  <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>1. Nama Proyek </td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue(item?.cvl_contract_branch?.name)} &nbsp;</td>
                </tr>
                <tr>
                  <td valign="top" style={{ width: "160px", verticalAlign: "top" }}>2. Lokasi Proyek  </td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue(item?.cvl_contract_branch?.description)}</td>
                </tr>
                <tr>
                  <td valign="top">3. Jenis Pekerjaan</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>
                    {validValue(item?.cvl_contract_cvl_account?.name)}</td>
                </tr>
                {/* <tr>
                            <td valign="top">4. Nilai Kontrak</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>{validValue("Rp" + currencyFormat(item.amount))} <p><em>{numberToWords(item.amount)}</em></p></td>
                          </tr> */}
                <tr>
                  <td valign="top">4. Waktu Pelaksanaan</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>{validValue("Sejak Tanggal Surat Tugas ini turunkan")} {validValue(handleValidDate(item.startat) + " sampai dengan " + handleValidDate(item.endat))}</td>
                </tr>
                <tr>
                  <td valign="top">5. Masa Pemeliharaan</td>
                  <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                  <td valign="top" style={{ verticalAlign: "top" }}>3 x 30 (Sembilan puluh) hari kalender</td>
                </tr>
                {/* <tr>
                            <td valign="top">7. Cara Pembayaran</td>
                            <td valign="top" style={{ width: "20px", verticalAlign: "top" }}>:</td>
                            <td valign="top" style={{ verticalAlign: "top" }}>45 Hari setelah tanggal invoice (Retensi 5%)</td>
                          </tr> */}
              </tbody>
            </table>

            <table style={{ marginBottom: "10px", marginTop: "10px", width: "100%", border: "1px solid #333" }}>
              <thead>
                <tr className="bg-soft-item" >
                  <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>No</th>
                  <th style={{ padding: "3px", border: "1px solid #333" }}>Pekerjaan</th>
                  <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Blok</th>
                  <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Satuan</th>
                  <th className="text-center" style={{ padding: "3px", border: "1px solid #333" }}>Volume</th>
                  <th className="text-end" style={{ padding: "3px", border: "1px solid #333" }}>Harga</th>
                  <th className="text-end" style={{ padding: "3px", border: "1px solid #333" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {jobList.length > 0 && (jobList || []).sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })).map((o, i) => {
                  let completed = o.weight_finished && o.completed ? parseFloat(o.weight_finished / o.completed / item.unit.length).toFixed(2) : 0;
                  return (
                    <tr key={i} className="product">
                      <td className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{i + 1}</td>
                      <td valign="top" className="text-start" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{o.label}</td>
                      <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>
                        {(item.block || []).map((obj) => {
                          return obj.label + " ";
                        })}
                      </td>
                      <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>Unit</td>
                      <td valign="top" className="text-center" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{item.unit.length}</td>
                      <td valign="top" className="text-end" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{currencyFormat(parseFloat(o.amount))}</td>
                      <td valign="top" className="text-end" style={{ height: "14px", padding: "3px", border: "1px solid #333" }}>{currencyFormat(parseFloat(o.amount) * item.unit.length)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <p style={{ fontSize: "14px", marginTop: "15px", marginBottom: "15px" }}>
              PENERIMA TUGAS sudah harus melaksanakan kegiatannya sejak Surat Tugas ini diterbitkan. Demikian Surat Tugas ini dibuat untuk segera dilaksanakan.
            </p>
            <Table
              className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
              style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td valign="top" className="w-50">
                    <p className="mb-0 text-center">BOGOR, {validValue(handleValidDate(item.createdat))}</p>
                    <p className="mb-5 pb-3 fw-semibold text-center">PEMBERI KERJA</p>
                    <p style={{ height: "5px", marginBottom: "10px" }}></p>
                    <p className="mt-5 text-center">{validValue(item?.cvl_contract_createdby?.name)}</p>
                  </td>
                  <td valign="top" className="w-50">
                    <p className="mb-0 text-center">PENERIMA TUGAS</p>
                    <p style={{ height: "40px" }}></p>
                    <p className="mt-5 text-center">{validValue(item?.cvl_contract_vendor?.name)}</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          :
          <>
            <Col lg={12}>
              <CardHeader className="border-bottom-dashed pt-2 pb-2 pe-3 ps-3">
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="50" />
                    <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="50" />
                    <div className="mt-sm-3 mt-3">
                      <h6 className="text-uppercase fw-semibold">{item?.cvl_contract_client?.name}</h6>
                      <p className="mb-1">{item?.cvl_contract_branch?.name}</p>
                      <p className="mb-1">Suplier: {item?.cvl_contract_vendor?.name}</p>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-2 pb-2 pe-3 ps-3">
                <Row className="g-3">
                  <Col lg={3} xs={3}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">No ST</p>
                    <h5 className="fs-14 mb-0">
                      #<span id="invoice-no">{item.transaction_no || "PKG" + handleValidDate(item.transactionat, "YYYYMMDD") + item.id}</span>
                    </h5>
                  </Col>
                  <Col lg={5} xs={5}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">Blok</p>
                    <h5 className="fs-14 mb-0">
                      {(item.block || []).map((obj, key) => {
                        return (
                          <span key={key} className="badge fs-14 text-uppercase badge-soft-light text-dark" >
                            {obj.label}
                          </span>
                        );
                      })}
                      <span className="badge fs-14 text-uppercase badge-soft-light text-dark">({item?.unit?.length} Unit)</span>
                    </h5>
                  </Col>
                  <Col lg={2} xs={2}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal Mulai</p>
                    <h5 className="fs-14 mb-0">
                      <span id="invoice-date">{handleValidDate(item.transactionat)}</span>
                    </h5>
                  </Col>
                  <Col lg={2} xs={2}>
                    <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal Berakhir</p>
                    <h5 className="fs-14 mb-0">
                      <span id="invoice-date">{handleValidDate(item.dueat)}</span>
                    </h5>
                  </Col>
                </Row>
              </CardBody>
              <CardBody className="pt-2 pb-2 pe-3 ps-3">
                <div>
                  <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                    <thead>
                      <tr className="table-active">
                        <th scope="col" style={{ width: "50px" }}>
                          #
                        </th>
                        <th scope="col" className="text-start">Detail Pekerjaan</th>
                        <th scope="col">Nilai Pekerjaan</th>
                        <th scope="col">% Bobot</th>
                        <th scope="col">Hasil Opname</th>
                        <th scope="col">% Opname</th>
                        <th scope="col">Nilai Opname</th>
                      </tr>
                    </thead>
                    <tbody id="products-list">
                      {jobList.length > 0 && (jobList.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })) || []).map((o, i) => {
                        let completed = o.weight_finished && o.completed ? parseFloat(o.weight_finished / o.completed / item.unit.length).toFixed(2) : 0;
                        return (
                          <tr key={i} id={i} className="product">
                            <th scope="row" className="product-id" style={{ height: "14px" }}>{i + 1}</th>
                            <td className="text-start" style={{ height: "14px" }}>{o.label}</td>
                            <td style={{ height: "14px" }}>{currencyFormat(parseFloat(o.amount))}</td>
                            <td style={{ height: "14px" }}>{Math.round(o.weight ?? 0)} %</td>
                            <td style={{ height: "14px" }}>{parseFloat(o.completed ?? 0)} dari {item.unit.length}</td>
                            <td style={{ height: "14px" }}>{(completed * o.completed ?? 0).toFixed(2)} %</td>
                            <td className="fw-semibold" style={{ height: "14px" }}>{completed ? currencyFormat(parseFloat(o.completed * o.amount)) : 0} </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div className="border-top border-bottom border-top-dashed mt-2 mb-3 pb-3">
                  <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto me-5" style={{ width: "250px" }}>
                    <tbody>
                      <tr>
                        <th>Total Bobot Tercapai</th>
                        <th className="text-end">{progressTotal} %</th>
                      </tr>
                      <tr>
                        <th>Harga Pekerjaan</th>
                        <th className="text-end">Rp{currencyFormat(item.amount)}</th>
                      </tr>
                      <tr>
                        <th className="text-danger">Retensi Pekerjaan (10%)</th>
                        <th className="text-end text-danger">Rp{currencyFormat(0.10 * item.amount)}</th>
                      </tr>
                      <tr>
                        <th>Hasil Opname Pekerjaan</th>
                        <th className="text-end">Rp{currencyFormat(progressPrice)}</th>
                      </tr>
                      <tr>
                        <th className="text-success">Terbayar</th>
                        <th className="text-end text-success">Rp{currencyFormat(item.paid_amount || 0)}</th>
                      </tr>
                      <tr className="border-top fs-15">
                        <th scope="row">SISA PEMBAYARAN</th>
                        <th className="text-end">Rp{currencyFormat(item.amount - (item.paid_amount || 0))}</th>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <Table
                  className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                  style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="w-50">
                        <p className="mb-0 text-center">Bogor, {handleValidDate(item.createdat)}</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{item?.cvl_contract_vendor?.name}</p>
                        <p style={{ height: "10px" }}></p>
                        <p className="mt-5 text-center">................................</p>
                      </td>
                      <td className="w-50">
                        <p className="mb-0 text-center">Bogor, {item.approvedat && handleValidDate(item.approvedat)}</p>
                        <p className="mb-0 text-center">Disetujui Oleh</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{item?.cvl_contract_approvedby?.name}</p>
                        <p style={{ height: "10px" }}></p>
                        <p className="mt-5 text-center">................................</p>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Col>
          </>
        }
        <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
          <style>{`@media print {.pagebreak { page-break-after: always; } }`}</style>
        </div>
        <div className="bg-white" style={{ padding: "40px 30px 40px 30px" }}>
          <h3 className="text-muted mb-1 text-uppercase fw-semibold">DETAIL BLOK DAN UNIT</h3>
          {(item.block || []).map((obj, key) => {
            return (
              <div key={key}>
                <p className="fs-14 text-uppercase mb-1" >
                  BLOK {obj.label}
                </p>
                <div className="gap-2 fs-12 mb-2">
                  {(item.unit.filter(x => x.label.substring(0, 2) === obj.label || x.label.substring(0, 3) === obj.label) || []).map((uni, key) => {
                    return (
                      <span key={key} className="badge text-uppercase badge-soft-primary me-2 mb-2">
                        {uni.label}
                      </span>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
};

export default PrintDoc;
